import { Pipe, PipeTransform } from '@angular/core';
import { getProductGroupIconName } from '../device-product-group-functions';
import { MmuDeviceProductGroup } from '../models/device-product-group';


@Pipe({
  name: 'deviceProductGroupIcon'
})
export class MmuDeviceProductGroupIconPipe implements PipeTransform {
  transform(value: MmuDeviceProductGroup, fallback = 'question'): string {
    return getProductGroupIconName(value, fallback);
  }
}
